import { IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425 } from "@faire/web-api--source/indigofair/settings/IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingEnableSearchIrrelevanceDifferentiation = (): boolean => {
  return useSetting(IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425, false);
};

export const useAssignSearchIrrelevanceDifferentiation = () =>
  useAssignSetting(IRRELEVANCE_CAROUSEL_DIFFERENTIATION_250425);
